




























import { Component, Vue, Prop } from 'vue-property-decorator'
import ChangeLogPreviewModal from './ChangeLogPreview.modal.vue'

@Component({
  components: {
    ChangeLogPreviewModal
  }
})
export default class ChangeLogModal extends Vue {
  @Prop() changeLog: any
}
